import { createAsyncThunk } from '@reduxjs/toolkit';
import type { DashboardPerScopeValueRequest, DashboardPerScopeValueResponse } from '@api/domain/types';
import { DashboardRequestType } from '@api/domain/types';
import type { AppDispatch, RootState } from '@store/types';
import { backendCall, createApiCall } from '@reducers/utils';

const PAGE_SIZE = 20;

export interface FetchDashboardPerScopeValueListArgs {
  params: Omit<DashboardPerScopeValueRequest, '$type' | 'pagination'> & {
    pageNumber: number;
  };
  append: boolean;
  signal?: AbortSignal;
}

export interface FetchDashboardPerScopeValueListResult {
  response: DashboardPerScopeValueResponse | undefined;
  append: boolean;
  pageNumber: number;
}

export const fetchDashboardPerScopeValueList = createAsyncThunk<
  FetchDashboardPerScopeValueListResult,
  FetchDashboardPerScopeValueListArgs,
  { state: RootState; dispatch: AppDispatch }
>('dashboard/fetchDashboardPerScopeValueList', async ({ params, append, signal }, { dispatch }) => {
  const { pageNumber, ...rest } = params;
  const response = await dispatch(
    backendCall(
      createApiCall((api) => api.dashboard.getDashboardPerScopeValue, {
        params: {
          $type: DashboardRequestType.PerScopeValue,
          ...rest,
          pagination: { pageNumber, pageSize: PAGE_SIZE, includeCount: true },
        },
        signal,
      })
    )
  );

  return { response, append, pageNumber };
});
